export class CreateBusinessDTO {
  firstName: string = "";
  lastName: string = "";
  userName: string = "";
  email: string = "";
  businessName: string = "";
  businessEmail: string = "";
  industry: string = "";
  businessAddress: string = "";
  businessPhoneNumber: string = "";
  password: string = "";
  placeId: string = "";

  constructor(data: Partial<CreateBusinessDTO> = {}) {
    Object.assign(this, data);
    if (this.email) {
      this.userName = this.email;
    }
  }
}
